"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = exports.claimsValidationSchema = exports.claimValidationSchema = void 0;
const yup_1 = require("yup");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const validation_1 = require("../../../../../validation");
exports.claimValidationSchema = (0, yup_1.object)().concat(validation_1.vestingValidationSchema).concat(mui_inputs_asset_1.templateAssetValidationSchema);
exports.claimsValidationSchema = (0, yup_1.object)().shape({
    claims: (0, yup_1.array)().of(exports.claimValidationSchema).required("form.validations.valueMissing"),
});
exports.validationSchema = (0, yup_1.object)().shape({
    files: (0, yup_1.array)().min(1, "form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map